"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenMenu = void 0;
var Types_1 = require("Tokens/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var WidgetMenuButton_1 = __importDefault(require("../WidgetMenuButton"));
var TokenInput_1 = __importDefault(require("./TokenInput"));
var classnames_1 = __importDefault(require("classnames"));
var TokenMenu = (function (_super) {
    __extends(TokenMenu, _super);
    function TokenMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.onTokenChange = function (token) {
            var _a = _this.props, confirmToken = _a.confirmToken, removeToken = _a.removeToken;
            if (token) {
                confirmToken(token);
            }
            else {
                removeToken();
            }
            _this.close();
        };
        _this.onTokenMatchedBySearch = function (token) {
            _this.tokenMatchedBySearch = token;
        };
        _this.onClickConfirm = function () {
            if (_this.tokenMatchedBySearch) {
                _this.onTokenChange(_this.tokenMatchedBySearch);
            }
            else {
                _this.close();
            }
        };
        _this.onClickTokenButton = function () {
            var _a = _this.props, token = _a.token, removeToken = _a.removeToken, removeEvenWhenEmpty = _a.removeEvenWhenEmpty;
            if (!!(token === null || token === void 0 ? void 0 : token.name) || removeEvenWhenEmpty) {
                removeToken();
            }
            _this.close();
        };
        _this.close = function () {
            var close = _this.props.close;
            if (close) {
                close();
            }
        };
        return _this;
    }
    TokenMenu.prototype.render = function () {
        var _a = this.props, type = _a.type, token = _a.token, className = _a.className, removeEvenWhenEmpty = _a.removeEvenWhenEmpty, hideConfirmButton = _a.hideConfirmButton;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("token-menu", className) },
            react_1.default.createElement(TokenInput_1.default, { type: type, token: token, onTokenChange: this.onTokenChange, onTokenMatchedBySearch: this.onTokenMatchedBySearch }),
            !hideConfirmButton && react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Tick, null), onMouseDown: this.onClickConfirm }),
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: !!(token === null || token === void 0 ? void 0 : token.name) || removeEvenWhenEmpty ? react_1.default.createElement(icons_1.RemoveToken, null) : react_1.default.createElement(icons_1.Tokens, null), onMouseDown: this.onClickTokenButton })));
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof Types_1.Token !== "undefined" && Types_1.Token) === "function" ? _a : Object)
    ], TokenMenu.prototype, "tokenMatchedBySearch", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenMenu.prototype, "onTokenMatchedBySearch", void 0);
    TokenMenu = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], TokenMenu);
    return TokenMenu;
}(react_1.default.Component));
exports.TokenMenu = TokenMenu;
